document.addEventListener('DOMContentLoaded', function () {
    // Modal elements
    const externalUrlSpan = document.getElementById('externalUrl');
    const proceedBtn = document.getElementById('proceedBtn');

    const excludedDomains= ['service1.org', 'servicefirst', 'secure.loanspg.com', 'connect.segmint.net', 'culookup.com'];
    const excludedProtocols= ['tel:', 'mailto:', 'javascript'];
    const selector = 'a[href*="://"]:not([href*="://'.concat(location.host, '"])');

    console.group('external link check')

    document
        .querySelectorAll(selector)
        .forEach((e) => {            
            const link = e.closest('a[href]');
            if(link) {                
                const href = link.getAttribute('href');
                const url = new URL(href);


                if(href.startsWith('#')) {
                    console.log('link failed #')
                    return;
                }
                
                if(excludedProtocols.some(x => url.protocol === x)) {
                    console.log('link is an excluded protocol')
                    return;
                }

                for(let i = 0; i < excludedDomains.length; i++) {
                    const domain= excludedDomains[i];

                    if(url.hostname === domain) {
                        return;
                    }
                }
                
                e.setAttribute('data-bs-link', e.getAttribute('href'));
                e.setAttribute('data-bs-toggle', 'modal');
                e.setAttribute('data-bs-target', '#leavingSiteModal');
            }
        });
    console.groupEnd();

    const modal =  document.getElementById('leavingSiteModal');
    let externalUrl = '';
    if(modal) {
        document.addEventListener("show.bs.modal", (e) => {
            const button = e.relatedTarget;
            externalUrl = button.getAttribute('data-bs-link');
            if (externalUrlSpan)
                externalUrlSpan.textContent = externalUrl;
        });

        // Reset target URL when modal is hidden
        modal
            .addEventListener('hidden.bs.modal', function () {
                externalUrl = '';
                
                if (externalUrlSpan)
                    externalUrlSpan.textContent = '';
            });

        proceedBtn.addEventListener('click', function () {
            window.open(externalUrl, '_blank', 'noopener,noreferrer');
        });
    }
});